/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=3e5f8fab&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=3e5f8fab&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5f8fab"]])

export default __exports__